import config from 'garaje/config/environment';

export default function () {
  const originalUrlPrefix = this.urlPrefix;
  this.urlPrefix = config.teamsPluginHost;

  this.get('/a/msteams-plugin-v2/private/chat-bot/:pluginInstallId/channels', function (schema, request) {
    let channels = schema.teamsChannels.all();
    const filter = request.queryParams['search'];
    if (filter) {
      channels = channels.filter((channel) => channel.name.toLowerCase().includes(filter.toLowerCase()));
    }
    // return result as a simple array of POJOs, rather than a full-blown JSONAPI response
    return channels.models.map(({ id, name }) => ({ id, name }));
  });

  this.urlPrefix = originalUrlPrefix;
}
